// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"36e20782","94":"d51879ec","116":"a954fdc4","173":"0b1e1ba1","297":"de70ae43","362":"e67ec35e","434":"0a27cf54","472":"27df2f12","588":"e6ffa136","599":"eede9ae2","685":"1c849015","787":"4103fb6f","844":"b0c84602","928":"56f9e5b1","934":"8a6f7ba8","980":"b81bed26"}[chunkId] + ".chunk.js";
};